import { gql } from "@apollo/client";

export const getRetailersAuth = gql`
  query getRetailers($enableExperimentalRetailers: Boolean) {
    Retailers(enableExperimentalRetailers: $enableExperimentalRetailers) {
      retailerId
      name
      color
      displayName
      type
      currencySymbol
      locale
      logo
      baseOrderUrl
      isBrandClubReady
      isSocialPlatform
      retailerConnectRewardAmount
      existingRetailerConnectReward
      retailerType
      parentRetailerId
      parentDisplayName
      sortScore
      tosUrl
      syncConfig
      checkoutConfig
      retailerLoginUsernameFieldTypes
      retailerAccountPageUrl
    }
  }
`;

export const getSyncEnabledRetailersAuth = gql`
  query getSyncEnabledRetailers($enableExperimentalRetailers: Boolean) {
    SyncEnabledRetailers(enableExperimentalRetailers: $enableExperimentalRetailers) {
      retailerId
      name
      color
      displayName
      type
      currencySymbol
      locale
      logo
      baseOrderUrl
      isBrandClubReady
      isSocialPlatform
      retailerConnectRewardAmount
      existingRetailerConnectReward
      retailerType
      parentRetailerId
      parentDisplayName
      sortScore
      tosUrl
      syncConfig
      checkoutConfig
      retailerLoginUsernameFieldTypes
      retailerAccountPageUrl
    }
  }
`;

export const getCheckoutEnabledRetailersAuth = gql`
  query getCheckoutEnabledRetailers($enableExperimentalRetailers: Boolean) {
    CheckoutEnabledRetailers(enableExperimentalRetailers: $enableExperimentalRetailers) {
      retailerId
      name
      color
      displayName
      type
      currencySymbol
      locale
      logo
      baseOrderUrl
      isBrandClubReady
      isSocialPlatform
      retailerConnectRewardAmount
      existingRetailerConnectReward
      retailerType
      parentRetailerId
      parentDisplayName
      sortScore
      tosUrl
      syncConfig
      checkoutConfig
      retailerLoginUsernameFieldTypes
      retailerAccountPageUrl
    }
  }
`;
